export default __webpack_public_path__ + "static/media/cyan-circle.111fad52.png";